"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Float = exports.Header = exports.Description = exports.Buttons = exports.MaxWidthModal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.MaxWidthModal = (0, app_1.styled)(ui_1.Modal) `
  max-width: 40rem;
`;
exports.Buttons = app_1.styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  @media ${app_1.mobile} {
    flex-direction: column;
  }
`;
const HeaderWrap = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  > span {
    flex: 1;
  }
`;
exports.Description = (0, app_1.styled)(app_1.Text) `
  padding: 0 1rem 1rem 1rem;
`;
function Header({ title, name, required }) {
    return ((0, jsx_runtime_1.jsxs)(HeaderWrap, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", as: "p" }, { children: title })), (0, jsx_runtime_1.jsx)("div", Object.assign({ onClick: (ev) => ev.stopPropagation() }, { children: (0, jsx_runtime_1.jsx)(ui_1.Switch, { name: name, disabled: Boolean(required), defaultValue: Boolean(required) }) }))] }));
}
exports.Header = Header;
exports.Float = app_1.styled.div `
  z-index: 10;
  position: fixed;
  left: 2rem;
  bottom: 2rem;
  background: white;
  border-radius: ${(theme) => theme.radius.small};
  padding: ${(theme) => theme.spacing.small};
  max-width: min(40rem, 90vw);
  @media ${app_1.mobile} {
    right: 2rem;
  }
`;
